import React from 'react';

const Latest = () => {
  return (
    <div style={{ padding: '1rem' }}>
      <h1>Latest Updates</h1>
      
      <h2>2025-07-12</h2>
      <p><strong>Major Model Enhancement & Game Library Expansion</strong></p>
      <p>We've significantly improved our AI model to provide better rule clarifications for games with complex and extensive rulesets. Board game enthusiasts will especially notice improved accuracy when asking about intricate interactions in games like Twilight Imperium, Arkham Horror, and other rulebook-heavy titles.</p>
      <p>Additionally, we've expanded our game library with numerous new additions including:</p>
      <ul>
        <li><strong>Card Games:</strong> Magic: The Gathering, Star Wars Unlimited, Pokemon, Digimon, One Piece Card Game, and more</li>
        <li><strong>Board Games:</strong> Brass: Birmingham, Everdell, Rising Sun, Final Girl, Marvel Champions, and others</li>
        <li><strong>War Games:</strong> Multiple Axis & Allies editions, Shadowrun Sprawl Ops</li>
        <li><strong>Miniatures:</strong> Heroscape: Age of Annihilation, Combat Zone, Amtgard</li>
      </ul>
      <p>Our rules assistant now supports over 40 different games, making it your one-stop resource for quick and accurate rule clarifications during game night. Whether you're dealing with a complex Magic: The Gathering interaction or need clarification on Twilight Imperium's political phase, our enhanced AI is here to help keep your games flowing smoothly.</p>
      
      <h2>2025-06-12</h2>
      <p>Frontend framework updated to React</p>
      
      <h2>2025-05-30</h2>
      <p>Just geting started with the site as a PoC</p>
    </div>
  );
};

export default Latest;